import {
  CHANNEL_CATEGORIES,
  CHANNEL_KINDS,
  ChannelStatus
} from '@/models/channels'
import { mapStaffAsArray } from '@/utils/channel'

const uploadTestResultImageData = state => state.uploadTestResultImageData

const isLoggedStaffNotInCurrentChannel = (
  state,
  getters,
  rootState,
  rootGetters
) => {
  const loggedStaffId = rootGetters['channel/staff/loogedStaffId']
  return !state.currentChannel.staff?.[loggedStaffId]
}

const newChannel = (state, getters, rootState) => {
  const currentUser = rootState.user.user
  const staff = {
    id: currentUser.id,
    profileImageUrl: currentUser.profileImageUrl,
    fullName: currentUser.fullName,
    owner: true,
    lastSync: new Date(),
    roles: currentUser.roles
  }

  return {
    kind: CHANNEL_KINDS.CHANNEL,
    category: CHANNEL_CATEGORIES.ADMINISTRATIVE,
    subCategory: null,
    staff: {
      [staff.id]: staff
    },
    tags: []
  }
}

const currentChannel = state => {
  const { status, staff = {}, staffHistory = {} } = state.currentChannel
  const staffArray = mapStaffAsArray(staff)
  const staffs = { ...staff, ...staffHistory }
  const staffsArray = mapStaffAsArray(staffs)

  return {
    ...state.currentChannel,
    staffs,
    staffArray,
    staffsArray,
    isActive: status === ChannelStatus.ACTIVE,
    isMerged: status === ChannelStatus.MERGED,
    isArchived: status === ChannelStatus.ARCHIVED
  }
}

const currentChannelParticipants = state => isPrivate => {
  const { staff, channelPersonId: id, lastSync } = state.currentChannel

  const participants = staff
    ? Object.values(staff).map(({ id, lastSync }) => ({
        id,
        lastSync
      }))
    : []

  if (!isPrivate) {
    participants.push({ id, lastSync })
  }

  return participants
}

const loggedStaffLastSync = (state, getters, rootState, rootGetters) => {
  const loggedStaffId = rootGetters['channel/staff/loogedStaffId']
  return state.currentChannel.staff?.[loggedStaffId]?.lastSync
}

const channelMessagesMutationData =
  (state, getters, rootState, rootGetters) => isPrivate => {
    const loggedStaffId = rootGetters['channel/staff/loogedStaffId']
    const { channelPersonId } = state.currentChannel || {}
    const currentChannelParticipants =
      getters.currentChannelParticipants(isPrivate)
    const loggedStaffLastSync = getters.loggedStaffLastSync
    const lastSync = loggedStaffLastSync?.seconds || 0

    return {
      loggedStaffId,
      channelPersonId,
      currentChannelParticipants,
      lastSync
    }
  }

const channelMember = (state, getters, rootState, rootGetters) => {
  const member = rootGetters['member/getMemberById']({
    channelPersonId: state.currentChannel.channelPersonId
  })
  if (!member) return
  return {
    ...member,
    participantName: member.displayName,
    participantTooltip: `${member.displayName} - Membro`
  }
}

export default {
  uploadTestResultImageData,
  isLoggedStaffNotInCurrentChannel,
  newChannel,
  currentChannel,
  currentChannelParticipants,
  loggedStaffLastSync,
  channelMessagesMutationData,
  channelMember
}
